import {
  BaseFormElementData,
  BaseFormElementModel,
  BaseFormElementSettingsData,
  BaseFormElementState
} from '@/components/addons/registration/BaseFormElementModel';

export interface FormElementDawaSettingsData extends BaseFormElementSettingsData {
  only_address?: string;
  limit?: string;
  validate_dawa_input?: string;
  manual_input?: {
    allow?: string;
    on_empty?: string;
    label?: string;
  };
  fuzzy?: string;
}

export interface FormElementDawaData extends BaseFormElementData {
  settings?: FormElementDawaSettingsData;
}

export interface FormElementDawaValue {
  tekst: string;
  id?: string;
  kvhx?: string;
  data?: FormElementDawaValueData;
  adresse?: {
    id?: string;
    kvhx?: string;
  };
}

export interface FormElementDawaValueData {
  id?: string;
  status?: number;
  darstatus?: number;
  vejkode?: string;
  adresseringsvejnavn?: string;
  etage?: string;
  dør?: string;
  supplerendebynavn?: string;
  stormodtagerpostnr?: string;
  stormodtagerpostnrnavn?: string;
  adgangsadresseid?: string;
  x?: number;
  y?: number;
  navn?: string;
  postnr?: string;
  husnr?: string;
  vejnavn?: string;
  postnrnavn?: string;
  href?: string;
  kvhx?: string;
  kommunekode?: string;
}

export interface FormElementDawaState extends BaseFormElementState<FormElementDawaValue> {
  elementMessage?: string;
  onlyAddress?: boolean;
  limit?: number;
  validateDawaInput?: boolean;
  manualInput?: {
    allow?: boolean;
    onEmpty?: string;
    label?: string;
  };
  fuzzy?: boolean;
}

export class FormElementDawaModel extends BaseFormElementModel<
  FormElementDawaValue,
  FormElementDawaData,
  FormElementDawaState
> {
  parseFormElement(data: FormElementDawaData) {
    this.state.onlyAddress = data.settings?.only_address === '1';
    this.state.limit = data.settings?.limit ? Number(data.settings?.limit) : 10;
    this.state.validateDawaInput = data.settings?.validate_dawa_input === '1';
    this.state.fuzzy = data.settings?.fuzzy === '1';

    this.state.manualInput = this.state.manualInput ?? {};
    if (data.settings?.manual_input) {
      this.state.manualInput.onEmpty = data.settings.manual_input.on_empty;
      this.state.manualInput.label = data.settings.manual_input.label;
      this.state.manualInput.allow = data.settings.manual_input.allow === '1';
    } else {
      this.state.manualInput = undefined;
    }
  }

  getInitialValue(): FormElementDawaValue | undefined {
    return this.parseStringValue(this.getInitialStringValue() ?? '');
  }

  getStringifiedValue(): string | undefined {
    return this.state.value
      ? `${this.state.value.tekst}, ${this.state.value.adresse?.id}, ${this.state.value.adresse?.kvhx}`
      : undefined;
  }

  parseStringValue(value: string): FormElementDawaValue | undefined {
    if (value && value[0] === '{') {
      return JSON.parse(value) as FormElementDawaValue;
    }

    return undefined;
  }

  getSerializedPostValue(): string {
    return typeof this.state.value === 'object' ? JSON.stringify(this.state.value) : '';
  }

  getSerializedCookieValue(): string {
    return this.getSerializedPostValue();
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
